export default __webpack_public_path__ + "static/media/title_sp.e66945ed.png";